module.exports = __webpack_public_path__ + "static/media/warn01.e0c03055.mp3";